
import wx from 'weixin-js-sdk'
import CheckIcon from 'vux/src/components/check-icon/index.vue'


export default {
name: 'editUser',
components: {
wx,CheckIcon
},
data() {
return {
filePath: '',
title:'',
formData:{
title:'',
voice_status:false,
voice_phone:'',
head_name:'',
head_phone:'',
pic:'',
content:'',
},
voiceStatus:false,
voiceStatusText:'',
info:{},
}
},
created() {
this.config();
this.getInfo();
},
computed:{

},
watch:{
voiceStatus(key){
this.voiceStatusText = key ? '开启' : '关闭';
this.formData.voice_status = key;
}
},
methods: {
getInfo(){
this.$api.getInfo({}).then((res)=>{
if(res){
this.title = res.data.title;
this.filePath = res.data.pic_path;
this.formData.voice_status = res.data.voice_status ? true : false;
this.voiceStatus = res.data.voice_status ? true : false;
this.voiceStatusText = res.data.voice_status ? '开启' : '关闭';
this.formData.voice_phone = res.data.voice_phone;
this.formData.title = res.data.title;
this.formData.head_name = res.data.head_name;
this.formData.head_phone = res.data.head_phone;
this.formData.pic = res.data.pic;
this.formData.content = res.data.content;
}
})
},
submit() {












if(!this.formData.head_name){
this.$func.showToast('请输入团长姓名');
return false;
}
if(!this.formData.head_phone){
this.$func.showToast('请输入团长电话');
return false;
}
if(this.formData.voice_status && !this.formData.voice_phone){
this.$func.showToast('请输入语音电话号码');
return false;
}
this.$api.submitCommunity(this.formData).then((res)=>{
this.$func.showToast('提交成功');
this.getInfo();
});
},
config(){








let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false, //调试阶段建议开启
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"chooseImage",
"uploadImage",
]
});
}
})
},
uploadFile(){
let that = this;
wx.chooseImage({
count: 1,
sizeType: ['original', 'compressed'],
sourceType: ['album', 'camera'],
success: function (res) {
that.uploadImg(res.localIds);
}
});
},
uploadImg(localIds){
let localId = localIds.pop();
let that = this;
wx.uploadImage({
localId: localId,
success: function (res) {
that.$api.uploadsImg({serverId:res.serverId,path:'product'}).then((res)=>{
if(res){
that.filePath = res.data.url;
that.formData.pic = res.data.path;
}
})
}
});
},
}
}



// WEBPACK FOOTER //
// ./src/pages/editUser.vue